import BaseValidator from "./BaseValidator";

const emailValidator = Object.create(BaseValidator);

// http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
emailValidator.validateAgainstRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export default emailValidator.init();
